<template>
  <wui-select
    class="disabled:cursor-default! disabled:bg-black-100 disabled:border-black-200! [&_.wui-select__field]:bg-white"
    v-bind="$attrs"
    :model-value="modelValue"
    :items="items"
    @update:model-value="onChange"
  />
</template>
<script setup lang="ts">
import { SelectItem, WuiSelect } from '@wui/common-library'
import { ConferenceType } from '@wui/im'
import { computed } from 'vue'

import { useLocalization } from '@/shared/composables/localization'

defineProps<{
  modelValue: ConferenceType
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', id: ConferenceType): void
}>()

const { t } = useLocalization()

const items = computed<SelectItem[]>(() => [
  {
    label: t('common.creatingRegularChat'),
    value: ConferenceType.FREE_FOR_ALL,
    default: true,
  },
  {
    label: t('common.creatingModeratedChat'),
    value: ConferenceType.MODERATED,
  },
])

const onChange = (value: string | number) => {
  emits('update:modelValue', value as ConferenceType)
}
</script>
